import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-two-col-area-photo-button',
  templateUrl: './two-col-area-photo-button.component.html',
  styleUrls: ['./two-col-area-photo-button.component.css']
})
export class TwoColAreaPhotoButtonComponent implements OnInit {

  @Input() twoColAreaPhotoButton_params: any = {}

  isLoaded: boolean = false;

  img: any;

  constructor() {


    // this.twoColAreaPhotoButton_params.photo = this.twoColAreaPhotoButton_params.photo || 'assets/img/placeholder.png';

  }

  ngOnInit(): void {
    // console.log(this.twoColAreaPhotoButton_params)
    this.isLoaded = true;

  }

}
